import * as ss from 'superstruct';

/**
 * The resource that communicates users between platform and platform-ui
 */
export const UserResource = ss.object({
  id: ss.number(),
  email: ss.string(),
  name: ss.optional(ss.nullable(ss.string())),
  archived: ss.defaulted(ss.boolean(), false),
});

export type UserResource = ss.Infer<typeof UserResource>;
